import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Box, Button, Card, TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConfirmDelete from '../../../shared/components/ConfirmDelete';
import CustomDataGrid from '../../../shared/components/CustomDataGrid';
import { ERole } from '../../../shared/enums/user/ERole';
import { useDepartment } from '../../../shared/hooks/useDepartment';
import { useDepartmentColumns } from '../../../shared/hooks/useDepartmentColumns';
import { IDepartment } from '../../../shared/interfaces/department/IDepartment';
import { IUser } from '../../../shared/interfaces/user/IUser';
import { RootState } from '../../../store/store';
import EmployeeFormModal from './components/EmployeeFormModal';
import EmployeeFormModalBody from './components/EmployeeFormModalBody';

const AdminDepartments = () => {
  const { role } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  const { t } = useTranslation();
  const isNormalUser = role === ERole.USER;

  const {
    data,
    pagination,
    totalPages,
    count,
    setPagination,
    changeFilterHandler,
    setSelectedDepartment,
    setShowDeleteModal,
    selectedUserIds,
    showDeleteModal,
    selectedDepartment,
    setSelectedUserIds,
    isAddModalOpened,
    setIsAddModalOpened,
    closeDeleteModal,
    handleCreateDepartment,
    deleteHandler,
  } = useDepartment();
  const columns = useDepartmentColumns(
    setSelectedDepartment,
    setShowDeleteModal,
  );
  return (
    <>
      <Card>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingBottom: '20px',
          }}
        >
          <TextField
            onChange={(e) => {
              changeFilterHandler('name', e.target.value);
            }}
            label={t('general.searchByName')}
            sx={{
              width: { xs: '100%', md: 'auto' },
              paddingBottom: { xs: 2, md: 0 },
            }}
          />

          {!isNormalUser && (
            <Button
              variant={'contained'}
              onClick={() => setIsAddModalOpened(true)}
              sx={{ width: { xs: '100%', md: 'auto' } }}
            >
              <AddCircleOutlineOutlinedIcon sx={{ marginRight: '5px' }} />
              {t('button.addNewDepartment')}
            </Button>
          )}
        </Box>
        <CustomDataGrid
          hasNextPage={totalPages < pagination?.page}
          rows={data || []}
          columns={columns}
          rowCount={count}
          pagination={pagination}
          setPagination={setPagination}
          loading={data === undefined}
        />
      </Card>
      <EmployeeFormModal
        open={isAddModalOpened}
        handleClose={() => setIsAddModalOpened(false)}
        handleSubmit={handleCreateDepartment}
      >
        <EmployeeFormModalBody
          department={selectedDepartment as IDepartment}
          setDepartment={setSelectedDepartment}
          setSelectedUserIds={setSelectedUserIds}
          selectedUserIds={selectedUserIds}
        />
      </EmployeeFormModal>
      <ConfirmDelete
        open={showDeleteModal}
        title={selectedDepartment?.name}
        handleClose={closeDeleteModal}
        handleSubmit={() => deleteHandler(Number(selectedDepartment?.id))}
      />
    </>
  );
};

export default AdminDepartments;
